"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsSectionCard() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Section Card
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A card component specifically designed for content sections with header and content areas.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/section-card" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>A section card with header and content</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <SectionCard
            header={
              <>
                <CardTitle>Card Title</CardTitle>
                <CardDescription>Card description text goes here.</CardDescription>
              </>
            }
            contentClassName="p-6"
          >
            <Text className="text-sm text-muted-foreground">
              This is the content area of the section card. You can put any content here.
            </Text>
          </SectionCard>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">header</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Header content (CardTitle, CardDescription)</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">children</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Card content</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">contentClassName</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Additional classes for content area</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
